import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index/index'
import ProxyPage from '@/views/index/proxy'
import VideoRoom from '@/views/videoRoom/index'
import VideoRoomChild from '@/views/videoRoom/child'
import PersonalLayout from '@/components/personal/layout'
import PersonalBaeInfo from '@/views/personal/baseInfo'
import AdultExamApply from '@/views/adultExamApply'
import MyCourse from '@/views/course/myCourse'
import CourseData from '@/views/course/data'
import Exam from '@/views/exam/exam'
import TransferPage from '@/views/exam/transferPage'
import answerLayout from '@/views/questions/answerLayout'
import AnswerPage from '@/views/questions/answerPage'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: '',
    redirect: '/index',
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
  },
  {
    path: '/videoRoom',
    name: 'videoRoom',
    component: VideoRoom,
    redirect: '/videoRoom/videoRoomChild',
    children: [
      {
        path: 'videoRoomChild',
        name: 'videoRoomChild',
        component: VideoRoomChild,
      },
    ],
  },
  {
    path: '/person',
    name: 'person',
    redirect: '/person/base',
    component: PersonalLayout,
    children: [
      {
        path: 'base',
        name: 'baseInfo',
        component: PersonalBaeInfo,
      },
      {
        path: 'course',
        name: 'myCourse',
        component: MyCourse,
      },
      {
        path: 'exam',
        name: 'exam',
        component: Exam,
      },
      {
        path: 'examTransferPage',
        name: 'examTransferPage',
        component: TransferPage,
      },
      {
        path: 'data',
        name: 'courseData',
        component: CourseData,
        meta: {
          fullScreen: false,
          homePages: true,
        },
      },
      {
        path: 'adultExamApply',
        name: 'adultExamApply',
        component: AdultExamApply,
        meta: {
          fullScreen: false,
          homePages: true,
        },
      },
    ],
  },
  {
    path: '/proxyPage',
    name: 'proxyPage',
    component: ProxyPage,
  },
  {
    path: '/question',
    name: 'question',
    redirect: '/question/blank',
    component: answerLayout,
    children: [
      {
        path: 'blank',
        name: 'questionBlank',
        component: AnswerPage,
        meta: {
          fullScreen: false,
          homePages: true,
        },
      },
    ],
  },
  {
    path: '*',
    name: '404',
    component: {
      template: '<h1>404找不到页面</h1>',
    },
  },
]

export default new Router({
  routes: routes,
})



// WEBPACK FOOTER //
// ./src/router/index.js